import React from "react"
import * as util from "shared/graphs/util"
import * as common from "story/components/graphs/common"
import * as screen from "shared/screen"
import * as recharts from "recharts"

// Sample data
// [
//   {
//     year: 0,
//     counter: 0,
//     minimumBalance: 0
//   },
//   {
//     year: 1,
//     counter: 1,
//     minimumBalance: 1
//   }
// ]

const getColor = (colors, idx) => (colors || common.colors)[idx]

/*
 * values: list of lists, each row having [xAxisTick, v1, v2, ...] coordinates
 *         to produce the line graph
 */
export default ({
  values = [],
  xAxis = "Years",
  yAxis = "Values",
  color,
  colors,
  tooltip,
  formatter = "default",
  customTooltipStyles = {},
  disabled = false,
  ariaLabel,
  type,
  referenceLine,
  refLineLabel
}) => (
  <util.Chart className={type} ariaLabel={ariaLabel} type={type}>
    <util.AxisLabel label={yAxis} className="yaxis" type={type} />
    <recharts.ResponsiveContainer width={"100%"} height={"100%"}>
      <recharts.LineChart data={util.toRecharts(values)} margin={{right: 20, top: 20, left: 12}}>
        <recharts.XAxis
          dataKey="name"
          interval={0}
          axisLine={false}
          tickLine={false}
          ticks={screen.getScreenWidth() < 620 ? util.staggerTicks(values, "small") : util.staggerTicks(values)}
          tick={util.xAxisTickStyles}
        />
        <recharts.YAxis type="number" domain={[0, "dataMax"]} axisLine={false} tickLine={false} tickFormatter={util.getFormatter(formatter)} tick={util.yAxisTickStyles} />
        <recharts.ReferenceLine
          x={referenceLine}
          stroke={getColor(colors, 1)}
          strokeWidth={2}
          strokeDasharray="7 4"
          label={{
            position: "insideBottomLeft",
            angle: -90,
            offset: 0,
            dx: 12,
            value: refLineLabel,
            fill: color || getColor(colors, 1),
            fontSize: 11,
            style: {textTransform: "uppercase", letterSpacing: "1.5px", fontWeight: 600}
          }}
        />
        {!disabled &&
          util.forEachSet(values, (idx) => (
            <recharts.Line
              type="monotone"
              key={idx}
              dataKey={idx}
              stroke={color || getColor(colors, idx)}
              strokeWidth={2.5}
              activeDot={{
                stroke: color || getColor(colors, idx),
                strokeWidth: 2,
                r: 4
              }}
              isAnimationActive={false}
            />
          ))}
        {!disabled && tooltip && <recharts.Tooltip {...Object.assign({}, common.tooltipProps(customTooltipStyles), {tooltip})} />}
      </recharts.LineChart>
    </recharts.ResponsiveContainer>
    <util.AxisLabel label={xAxis} className="xaxis" type={type} />
  </util.Chart>
)
